export default __webpack_public_path__ + "static/play_button-fe9f6b3709c0d1d77287e530f0199782.svg";